import React, {useState} from 'react';
import {Button, Form, Card, Alert, FloatingLabel} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import AuthenticateAPIs from '../../../MasonyFixingsAPIs/AuthenticateAPIs/AuthenticateAPIs';
import './Login.css';

import GreyLogo from '../../../Resources/Images/MF_Logo_NegGrey.png';

function LogIn() {

    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");

    const [requesting, setRequesting] = useState(false);
    const [invalidForm, setInvalidForm] = useState(false);
    const [invalidMsg, setInvalidMsg] = useState('');
    
    // Verify user credentials
    const handleSubmit = e => {

        e.preventDefault();
        e.stopPropagation();

        setRequesting(true);

        const postJSON = {
            username: userName,
            password: password
        }
        AuthenticateAPIs.PostAuthenticate(postJSON)
        .then((response) => {
            setRequesting(false);
            if(response.status === 200){
                navigate('/');
            }
        })
        .catch((err) => {
            setRequesting(false);
            if(err.response.status === 404){
                setInvalidForm(true);
                setInvalidMsg('Incorrect Username');
            }
            else if(err.response.status === 401){
                setInvalidForm(true);
                setInvalidMsg('Incorrect Password');
            }
        })
        
    }


    return(
        <div className="login-container">
  <Card className="login-card">
    <Card.Body>
      <div className="logo-container">
        <img src={GreyLogo} alt="Grey" />
      </div>

      <h4 className="login-title">Welcome back</h4>
      <p className="login-subtitle">Please log in to continue</p>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <FloatingLabel label="Username">
            <Form.Control
              type="text"
              placeholder="Username"
              value={userName}
              isInvalid={invalidForm}
              onChange={(e) => setUserName(e.target.value)}
              required
            />
          </FloatingLabel>
        </Form.Group>

        <Form.Group className="mb-3">
          <FloatingLabel label="Password">
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              isInvalid={invalidForm}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </FloatingLabel>
        </Form.Group>

        {invalidForm && <Alert variant="danger">{invalidMsg}</Alert>}

        <Button
          className="login-btn w-100"
          type="submit"
          disabled={requesting}
        >
          {requesting ? "Logging In..." : "Log In"}
        </Button>
      </Form>
    </Card.Body>
  </Card>
</div>
        
        );
}
export default LogIn;